<!-- agregar boton crear encuesta -->
<div *ngIf="hayUsuarios && !crearusuario && !editarusuario " class="contenedor-boton">
    <button 
      pButton 
      type="button" 
      icon="pi pi-plus" 
      class="p-button-rounded boton-rosado" 
      pTooltip="Crear Usuario"
      tooltipPosition="top"
      (click)="onCrearUsuario()">
    </button>
  </div>

<!-- Si hayEncuestas=false mostrar el componente app-crearusuario -->
<div *ngIf="(!hayUsuarios || crearusuario) && !editarusuario ">
    <app-crearusuario (creacionFinalizada)="onCreacionFinalizada()" [IdEncuesta]="opcionSeleccionada"></app-crearusuario>
</div>

<div *ngIf="editarusuario">
    <app-editarusuario [IdEncuesta]="opcionSeleccionada" [IdUsuario]="idUsuario" [Usuario]="Usuario"  (edicionFinalizada)="onEdicionFinalizada()"></app-editarusuario> 
</div>

<div *ngIf="hayUsuarios && !editarusuario && !crearusuario"> 
    <p-table [value]="usuarios" [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>Correo</th>
                <th>Nombre</th>
                <th>Crear registros</th>
                <th>Eliminar registros</th>
                <th>Editar registros</th>
                <th>Ver registros</th>
                <th>Opciones</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-usuario>
            <tr pSelectableRow>
                <td>{{ usuario.Email }}</td>
                <td>{{ usuario.Nombre }}</td>
                <td>
                    <input type="checkbox" [checked]="usuario.Crear" disabled>
                </td>
                <td>
                    <input type="checkbox" [checked]="usuario.Eliminar" disabled>
                </td>
                <td>
                    <input type="checkbox" [checked]="usuario.Editar" disabled>
                </td>
                <td>
                    <input type="checkbox" [checked]="usuario.Ver" disabled>
                </td>
                <td>
                    <!-- Botón para editar usuario -->
                    <button pButton pRipple type="button" icon="pi pi-pencil" 
                            class="p-button-rounded p-button-text p-button-warning"
                            title="Editar Usuario"
                            (click)="navigateToUsuario(usuario._id)">
                    </button>

                    <!-- Botón para crear contraseña -->
                    <button *ngIf="!usuario?.Clave || usuario?.Clave === ''" pButton pRipple type="button" icon="pi pi-key" 
                            class="p-button-rounded p-button-text p-button-success"
                            title="Crear Contraseña"
                            (click)="navigateToCrearContrasena(usuario._id)">
                    </button>
                </td>
                
            </tr>
        </ng-template>
    </p-table>
</div>


